module.exports = __webpack_public_path__ + "img/brisas8.ce9be437.jpg";